const ratios = new Map<string, number>();

export const GUESSED_RATIO = 2;

export function rememberRatio(url: string, width: number, height: number): void {
  if (width > 0 && height > 0) ratios.set(url, width / height);
}

export function ratioOf(url: string): number {
  return ratios.get(url) ?? GUESSED_RATIO;
}
